<template>
    <TooltipProvider :delay-duration="200">
        <div id="page-container" class="">
            <main class="min-h-screen w-full">
                <router-view />
            </main>
            <ReloadRequired v-if="isReloadRequired" />
            <BottomFooter v-if="!isEmbedded" />
            <!-- <VueQueryDevtools /> -->
        </div>
    </TooltipProvider>
</template>

<script setup>
import { ref, watch } from 'vue'
import { useRouter } from 'vue-router'
import { TooltipProvider } from 'reka-ui'
// import { VueQueryDevtools } from '@tanstack/vue-query-devtools'

import BottomFooter from '@/components/BottomFooter.vue'
import ReloadRequired from '@/components/ReloadRequired.vue'

const router = useRouter()

const { analytics } = useAnalytics()

const isReloadRequired = ref(false)
const { isEmbedded } = useSignalEmbedded()

// Initializes and subscribes the data month query at app root.
const { isError: isDataMonthError } = useDataMonth()

watch(isDataMonthError, (isError) => {
    if (!isError) return

    analytics.track({ event: 'Data Month Query Error' })
})

router.onError((error) => {
    if (error?.message.includes('dynamically imported module') && !isReloadRequired.value) {
        isReloadRequired.value = true
        analytics.track({ event: 'Reload Required' })
    }
})
</script>
